import { useContext, useEffect, useRef, useState } from 'react';
import { WebApiContext } from 'ascendon-web-api';
import { translateFault, generateUnhandledFault } from '../../helpers/faults';

function useRemoveMultiplePaymentInstruments() {
  const [fault, setFault] = useState(null);
  const [faultStatus, setFaultStatus] = useState(null);
  const [uiModel, setUiModel] = useState(null);
  const WebApi = useContext(WebApiContext);

  const isMounted = useRef(true);

  useEffect(
    () => () => {
      isMounted.current = false;
    },
    [],
  );

  const requestRemoveMultiplePaymentInstruments = (
    removePaymentInstrumentPayloads,
  ) => {
    const calls = [];

    removePaymentInstrumentPayloads.forEach(
      (removePaymentInstrumentPayload) => {
        calls.push(
          WebApi.subscriber({
            callName: 'RemovePaymentInstrument',
            keyFactors: ['RemovePaymentInstrument'],
            forceRefresh: true,
            payload: removePaymentInstrumentPayload,
          }),
        );
      },
    );

    Promise.all(calls)
      .then((response) => {
        if (isMounted.current) {
          setFaultStatus(false);
          const removeMultiplePaymentInstruments = response.reduce(
            (accumulator, currentValue) => {
              accumulator.push(currentValue?.data);
              return accumulator;
            },
            [],
          );
          setUiModel(removeMultiplePaymentInstruments);
        }
      })
      .catch((error) => {
        console.warn({ error });
        setFaultStatus((prevState) => !prevState);
        if (isMounted.current) {
          const code = error?.data?.Code;
          let errorMsg;
          if (!code) {
            const unknownFault = generateUnhandledFault(error.data);
            errorMsg = translateFault(unknownFault).translatedMessage;
            setFault(errorMsg);
          } else {
            errorMsg = translateFault(error.data).translatedMessage;
            setFault(errorMsg);
          }
        }
      });
  };
  return [uiModel, fault, requestRemoveMultiplePaymentInstruments, faultStatus];
}

export { useRemoveMultiplePaymentInstruments };
export default useRemoveMultiplePaymentInstruments;
